import { Request } from 'components/Request';
import requestErrorMessage from 'functions/requestErrorMessage';

// The live match room on the netplay page: whether the Chat view shows it in
// the conversation column, and the optimistic Close.
export const OPEN_MATCH_ROOM = 'OPEN_MATCH_ROOM';
export const LEAVE_MATCH_ROOM = 'LEAVE_MATCH_ROOM';
export const CLOSE_MATCH_ROOM_BEGIN = 'CLOSE_MATCH_ROOM_BEGIN';
export const CLOSE_MATCH_ROOM_FAIL = 'CLOSE_MATCH_ROOM_FAIL';

export const openMatchRoom = () => ({ type: OPEN_MATCH_ROOM });

export const leaveMatchRoom = () => ({ type: LEAVE_MATCH_ROOM });

// Exits the match. The room and its "Your match" entry go away at once; a
// refusal brings them back with the reason. A disputed match goes through the
// existing exit flow (Match#closeMatch), which asks for a dispute reason first.
export const closeMatchRoom = (match) => (dispatch) => {
	if(!match.canBeExited()) {
		return match.closeMatch().catch(() => {});
	}
	dispatch({ type: CLOSE_MATCH_ROOM_BEGIN, payload: match.id });
	return Request.apiv1('match/exit', { match_id: match.id })
		.then((response) => {
			if(response && response.error) {
				dispatch({ type: CLOSE_MATCH_ROOM_FAIL, payload: requestErrorMessage(response) });
			}
		})
		.catch((failure) => {
			dispatch({ type: CLOSE_MATCH_ROOM_FAIL, payload: requestErrorMessage(failure) });
		});
};
